import { entryPoint } from "./shared_entry";
import GroupLoginPageContainer from "../app/containers/group_login_page_container";

entryPoint(GroupLoginPageContainer, window.initialState, {
  noGlobalWrap: true,
  noInitialScroll: true,
});
